// Re-export from main firebase config
export { auth, db, storage, app } from "../firebase";
import { getFunctions } from "firebase/functions";
import { app } from "../firebase";

// Initialize additional services
export const functions = getFunctions(app);

export default app;
